import User from '@/api/admin_user.api.js'

/*eslint-disable */
export const getUsers = ({ commit }, data) => {
  return User.getUsers(data)
    .then(response => {
      commit("SET_USERS", response.data)
      return response;
    })
}

export const create = ({ commit }, data) => {
  return User.create(data)
      .then(response => response)
      .catch(err => err);
}

export const getDetailUser = ({ commit }, data) => {
  return User.getDetail(data)
      .then(response => {
        commit("SET_USER", response.data)
        return response;
      })
      .catch(err => err);
}

export const updateUser = ({ commit }, data) => {
  return User.update(data)
      .then(response => response)
      .catch(err => err);
}

export const updateUserAdmin = ({ commit }, data) => {
    return User.updateUserAdmin(data)
        .then(response => response)
        .catch(err => err);
}

export const deleteUser = ({ commit }, data) => {
  return User.delete(data)
      .then(response => response)
      .catch(err => err);
}

export const settingTemplateUser = ({ commit }, data) => {
  return User.settingTemplate(data)
      .then(response => response)
      .catch(err => err);
}

export const getTemplateUser = ({ commit }, data) => {
  return User.getTemplateUser(data)
      .then(response => {
        commit("SET_TEMPLATES", response.data)
        return response
      })
      .catch(err => err);
}

export const getCollectionUser = ({ commit }, data) => {
  return User.getCollectionUser(data)
    .then(response => {
      commit("SET_COLLECTIONS", response.data)
      return response
    })
    .catch(err => err)
}

/*eslint-enable */
